/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import * as Yup from 'yup';

import { ICorporateFormTranslation } from '@/main/modules/internationalization/types/corporate';

import { EFormImageLinksFileds } from './constants';

export const getFormImageLinksValidationSchema = (translation: ICorporateFormTranslation) => {
    return Yup.object().shape({
        [EFormImageLinksFileds.INPUT]: Yup.string()
        .url(translation.validation['field.link.incorrect']),
    });
};
